import type { ObjectId } from '@freightview/object-id'

import type { DTO } from '../core/index.ts'
import { vNonEmptyString, vObject, type vOutput } from '../validation/index.ts'
import type { UserProfile, UserSession } from './user.ts'

export type CarrierSession = UserSession & {
  active: boolean
}

interface CarrierShipper {
  accountId: string
  name: string
}

export type CarrierUserContext = {
  user: {
    profile?: UserProfile
    email: string
    carrierId?: string
    _id: ObjectId
    shippers: CarrierShipper[]
  }
  sessionId: string
}

export type CarrierUserContextDTO = DTO<CarrierUserContext>

export const liveEventsQuerySchema = vObject({
  carrierId: vNonEmptyString(),
})
export type LiveEventsQuery = vOutput<typeof liveEventsQuerySchema>
